export default {
    billing: {
        billingDetails: 'プランの詳細',
        buyMailPoints: '郵送ポイントの購入',
        changeSubscription: 'プランの変更',
    },
    client: {
        clientHistory: '取引先履歴',
        contact: '連絡先',
        documents: '書類',
        notes: 'メモの一覧',
        sendingSettings: '送付設定',
        summary: '概要',
    },
    documentSettings: {
        conversionSettings: '変換',
        customTemplates: 'カスタムテンプレート',
        documentApproval: '承認',
        documentPresets: '定型パターン',
        extendedDataFields: '追加項目',
        numbering: '書類番号',
        pdfFilenameSettings: 'PDFファイル名',
        tags: 'タグ',
        taxRegistrationNumber: '登録番号の表示',
    },
    history: {
        documentArchive: '発行書類控え',
        downloads: 'ダウンロード',
        events: 'イベント',
        sendingOrders: '送付履歴',
    },
    portal: {
        clientInbox: '取引先受信箱',
        clientInboxUsers: '設定',
        contactInformation: '[PH]Contact Information',
        personalInbox: 'マイ受信箱',
    },
    team: {
        groupsAndRoles: 'グループ / 役割',
        members: 'メンバー',
        revoked: '退会済み',
    },
    teamMember: {
        employeeRights: 'メンバーの権限',
        groups: 'グループ',
        notifications: '通知設定',
        overview: 'メンバー情報',
    },
    yourCompany: {
        billingAndPlan: 'プランの変更',
        dataExport: 'エクスポート',
        dataImport: 'インポート',
        earlyAccess: '早期アクセス',
        integrations: 'アプリ連携',
        settings: '設定',
    },
};
